import { buildPollResponseListSpec } from '@/aggregations/poll-responses';

export const PollResponseList = ({ pollId, pollResponseMap }) => ({
    name: 'PollResponseList',
    responseFormat: 'rows',
    build: ({ appIds, timeSeries, guideId, segmentId }) =>
        buildPollResponseListSpec({ appIds, timeSeries, guideId, pollId, segmentId, pollResponseMap })
});
